import { RuntimeSetting } from './ResponseType'

export enum IndexStatus {
  INITIALIZED = 'INITIALIZED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUSPENDED = 'SUSPENDED',
  FAILED = 'FAILED',
  SUCCEEDED = 'SUCCEEDED'
}

export interface IndexMetadata {
  runtime_setting: RuntimeSetting
  is_internal_uploaded_index: boolean
}

export interface Index {
  id: number
  org_id: number
  conn: {
    conn_type: string
    connection_metadata?: {
      is_self_hosted?: boolean
    }
  }
  name: {
    name: string
    branch: string
  }
  status: IndexStatus
  details: { reason: string } | null
  last_indexed_time: string | null
  indexer_metadata: IndexMetadata | null
}
